export const apiField = 'wind_directionality_factor_kd';
export default {
  type: 'Text',
  label: 'windDirectionalityFactorKd',
  missing: undefined,
  apiField,
  tooltip: undefined,
};

